// extracted by mini-css-extract-plugin
export default {"docusign":"styles_docusign__9upvF","icon":"styles_icon__LHQef"};